/**
 * MLD-2860
 * MLD-3886 for 2023 license.
 * MLD-5545 for 2024 license.
 * MLD-6898 for 2025 license. It expires on December 15, 2025.
 */
export default {
  LICENSE_KEY: 'fc8f6-2227b-abb62-f4c3b-dfc1d',
}
